import { isFeatureEnabledForPhoenix } from './helper/phoenixHelper';
import { PARTNERS } from './constants/partners';
import store from './store';
import { FEATURE_FLAGS } from './featureFlagsConstants';

export { FEATURE_FLAGS };

const features = [
  {
    name: FEATURE_FLAGS.DYNAMIC_LISTS,
    disabledPartners: [PARTNERS.BRANDNAMIC],
  },
  {
    name: FEATURE_FLAGS.CONTACT_SEARCH,
    disabledPartners: [PARTNERS.BRANDNAMIC],
  },
  {
    name: FEATURE_FLAGS.CONTACT_ACTIONS,
    disabledPartners: [PARTNERS.BRANDNAMIC],
  },
  {
    name: FEATURE_FLAGS.MACROS,
    disabledPartners: [PARTNERS.BRANDNAMIC],
  },
  {
    name: FEATURE_FLAGS.AUTOMATIONS,
    disabledPartners: [PARTNERS.BRANDNAMIC],
  },
  {
    name: FEATURE_FLAGS.ENTRYPOINT_LIST,
    disabledPartners: [PARTNERS.BRANDNAMIC],
  },
];

const isFeatureEnabledForPartner = (disabledPartners = []) => {
  const partner = store.getters['accounts/getPartner'];

  return disabledPartners.length === 0 || !disabledPartners.includes(partner);
};

export const isFeatureEnabled = (featureName) => {
  const currentFeature = features.find(({ name }) => name === featureName);

  if (!currentFeature) {
    return false;
  }

  return (
    isFeatureEnabledForPartner(currentFeature.disabledPartners) &&
    isFeatureEnabledForPhoenix(featureName)
  );
};
